import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

const BookingEarly = ({ days }) => (
  <li>{trans('property_show.instant_booking_modal.too_early', { days })}</li>
);

BookingEarly.propTypes = {
  days: PropTypes.number.isRequired
};

export default BookingEarly;
